module.exports = __webpack_public_path__ + "media/images/emblems/Oulens-sous-Echallens-coat_of_arms-b119bdd4c383df6c75a95f7c7c97ab2a.svg";